(() => {
  if (customElements.get('ss-size-picker')) return;
  customElements.define('ss-size-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.details = this.querySelector('details');
      this.targetOpen = this.details.open;
      this.onPickerClick = event => {
        const summary = event.target.closest('summary');
        if (summary && summary === this.querySelector('summary')) {
          event.preventDefault();
          this.setOpen(!this.targetOpen);
          return;
        }
        const button = event.target.closest('[data-variant-id]');
        if (button && this.contains(button)) this.selectVariant(button);
      };
      this.addEventListener('click', this.onPickerClick);
      this.onPickerKeydown = event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.setOpen(false);
          this.querySelector('summary').focus();
        }
      };
      this.addEventListener('keydown', this.onPickerKeydown);
      this.onOutsideClick = event => {
        if (!this.contains(event.target) && this.targetOpen) this.setOpen(false);
      };
      document.addEventListener('click', this.onOutsideClick);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onOutsideClick);
      this.removeEventListener('click', this.onPickerClick);
      this.removeEventListener('keydown', this.onPickerKeydown);
      if (this.motion) this.motion.cancel();
      this.initialized = false;
    }
    setOpen(open) {
      const panel = this.querySelector('.ss-size-options');
      const wasOpen = this.details.open;
      if (open === this.targetOpen && (this.motion || wasOpen === open)) return;
      this.targetOpen = open;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !panel.animate) {
        if (this.motion) this.motion.cancel();
        this.motion = null;
        panel.style.overflowY = '';
        this.details.open = open;
        return;
      }

      // Capture the visible height before cancelling an interrupted animation.
      const fromHeight = wasOpen ? panel.getBoundingClientRect().height : 0;
      if (this.motion) this.motion.cancel();
      this.details.open = true;
      panel.style.boxSizing = 'border-box';
      panel.style.overflowY = '';
      const fullHeight = panel.getBoundingClientRect().height;
      panel.style.overflowY = 'hidden';

      const animation = panel.animate(
        [
          { height: fromHeight + 'px' },
          { height: (open ? fullHeight : 0) + 'px' }
        ],
        {
          duration: open ? 450 : 220,
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
          fill: 'both'
        }
      );
      this.motion = animation;
      animation.onfinish = () => {
        if (this.motion !== animation) return;
        this.details.open = this.targetOpen;
        animation.cancel();
        panel.style.overflowY = '';
        this.motion = null;
      };
    }
    selectVariant(button) {
      const form = document.getElementById(this.dataset.formId);
      const product = this.closest('product-info');
      if (!form || !product) return;
      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;
      const id = button.dataset.variantId;
      const available = button.dataset.available === 'true';
      variantInput.value = id;
      variantInput.disabled = false;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelectorAll('[data-variant-id]').forEach(option => {
        option.setAttribute('aria-pressed', String(option === button));
      });
      const summary = this.querySelector('[data-ss-size-summary]');
      summary.replaceChildren();
      summary.append(button.querySelector('[data-ss-size-label]').cloneNode(true));
      summary.append(button.querySelector('.ss-size-description').cloneNode(true));
      this.setOpen(false);
      this.querySelector('summary').focus();
      const submit = form.querySelector('[type="submit"]');
      if (submit) {
        submit.disabled = !available;
        submit.classList.toggle('disabled', !available);
        submit.setAttribute('data-no-variant', 'false');
        const label = submit.querySelector('span:first-child');
        if (label) label.textContent = this.querySelector(
          available ? '[data-ss-add-label]' : '[data-ss-sold-label]'
        ).textContent;
      }
      const error = document.getElementById('variant-error-' + this.dataset.sectionId);
      if (error) { error.style.display = 'none'; error.hidden = true; }
      const spinner = product.querySelector('.loading-spinner-wrapper');
      if (spinner) spinner.classList.remove('hidden');
      const price = product.querySelector('[id^="price-"] .price');
      if (price) {
        const onSale = Boolean(button.dataset.compare);
        price.classList.toggle('price--on-sale', onSale);
        const regular = price.querySelector('.price__regular .price-item--regular');
        const sale = price.querySelector('.price__sale .price-item--sale');
        const compare = price.querySelector('.price__sale .price-item--regular');
        if (regular) regular.textContent = button.dataset.price;
        if (sale) sale.textContent = button.dataset.price;
        if (compare) compare.textContent = button.dataset.compare || '';
      }
      if (typeof product.updateURL === 'function') {
        product.updateURL(product.dataset.url, id);
      }
    }
  });
})();